// extracted by mini-css-extract-plugin
module.exports = {"box":"SelectableExplainer_box__1rJeh","borderSuccess":"SelectableExplainer_borderSuccess__3no-F","text-success":"SelectableExplainer_text-success__2SII6"};